import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import appfolioBg from 'src/img/appfolio-bg.jpg';
const mdBreakpoint = 1079.5;
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  tabletHeader: {
    display: 'none',
    background: 'linear-gradient(180deg, #009299 0%, #00AA8D 100%)',
    padding: '40px',
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      display: 'block',
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      zIndex: '10'
    }
  },
  splitContainer: {
    minHeight: '100vh',
    maxHeight: '100vh',
    overflow: 'hidden',
    width: '100vw',
    display: 'flex',
    backgroundColor: palette.shades[100],
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      flexDirection: 'column',
      overflow: 'auto'
    }
  },
  leftSplit: {
    width: '618px',
    maxWidth: '618px',
    flexGrow: '1',
    background: 'linear-gradient(180deg, #009299 0%, #00AA8D 100%)',
    padding: '40px',
    overflow: 'auto',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '40%'
    },
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      display: 'none'
    }
  },
  leftAppfolioSplit: {
    width: '618px',
    maxWidth: '618px',
    flexGrow: '1',
    padding: '40px',
    overflow: 'auto',
    backgroundImage: "url(".concat(appfolioBg, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'cover',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '40%'
    },
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      display: 'none'
    }
  },
  leftImg: {
    display: 'block',
    marginTop: '140px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'none'
    }
  },
  rightSplit: {
    display: 'flex',
    flexGrow: '1',
    alignItems: 'center',
    flexDirection: 'column',
    minHeight: '100vh',
    maxHeight: '100vh',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: '60%'
    },
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      width: '100%',
      marginTop: '110px',
      maxHeight: 'initial',
      minHeight: 'initial'
    }
  },
  breadcrumbsWrapper: {
    backgroundColor: palette.shades[100],
    padding: '20px 0',
    width: '100%',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    zIndex: '10',
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      position: 'sticky',
      top: '110px',
      left: '0',
      right: '0'
    }
  },
  breadcrumbsContent: {
    width: '582px',
    margin: '0 auto',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '0 40px'
    },
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      margin: '0 40px'
    }
  },
  rightBlockContainer: {
    overflow: 'auto',
    width: '100%',
    paddingBottom: '40px'
  },
  rightBlockContent: {
    width: '582px',
    margin: '0 auto',
    marginTop: '110px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial',
      marginLeft: '40px',
      marginRight: '40px',
      marginTop: '40px'
    },
    [breakpointsFunc.breakpoints.down(mdBreakpoint)]: {
      marginTop: '40px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: 'initial',
      margin: '0 24px'
    }
  },
  largeTop: {
    marginTop: '120px'
  }
}));
export default useStyles;